/* Version: 3.5.137 */
'use client';
import canadianTheme from '../theme/canadianTheme.js';
import deepMerge from './deepMerge.js';

function extendTheme(theme) {
  var baseTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : canadianTheme;
  return deepMerge(baseTheme, theme);
}

export { extendTheme as default };
